(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sweetweet-approved-product"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.swReady)return;root.dataset.swReady='true';
    var scope=root.closest('[data-section-type="product"]');
    var form=document.getElementById(root.dataset.formId);
    if(!scope||!form)return;
    var button=form.querySelector('[data-add-to-cart]');
    var bar=root.querySelector('[data-sw-sticky]');
    var alternatives=root.querySelector('[data-sw-alternatives]');
    var price=scope.querySelector('[data-product-detail-price]');
    var originalVisible=true;
    function sync(){
      button=form.querySelector('[data-add-to-cart]');
      var rect=button&&button.getBoundingClientRect();
      originalVisible=!!rect&&rect.height>0&&rect.bottom>0&&rect.top<window.innerHeight;
      var available=button&&!button.disabled&&button.getAttribute('aria-disabled')!=='true';
      var overlay=Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(function(el){return el.getClientRects().length>0&&getComputedStyle(el).visibility!=='hidden';});
      var editing=/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
      bar.hidden=!available||originalVisible||!!overlay||editing;
      document.body.classList.toggle('sw-sticky-active',!bar.hidden);
      if(price&&bar.querySelector('[data-sw-price]').textContent!==price.textContent)bar.querySelector('[data-sw-price]').textContent=price.textContent;
      if(alternatives)alternatives.hidden=!!available;
    }
    var scheduled=false;function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;sync();});}
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
    new MutationObserver(schedule).observe(form,{attributes:true,childList:true,subtree:true});
    if(price)new MutationObserver(sync).observe(price,{childList:true,characterData:true,subtree:true});
    bar.querySelector('button').addEventListener('click',function(){
      var target=scope.querySelector('.product-detail__options')||form;
      var gpo=scope.querySelector('.gpo-app');if(gpo)target=gpo;
      target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      var field=target.querySelector('input:not([type="hidden"]):not(.no-js),select:not(.no-js),textarea,button');if(field)field.focus({preventScroll:true});
    });
    document.addEventListener('focusin',sync);document.addEventListener('focusout',function(){setTimeout(sync,0)});form.addEventListener('change',sync);
    sync();
  }
  function run(){document.querySelectorAll('[data-sw-approved]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
  } catch(e) { console.error(e); }
})();

})();
